<template>
  <transition name="delay">
    <div v-show="isActive" class="grid absolute-block">
      <router-link
        :to="
          $i18nRoute({
            name: 'NewsDetail',
            params: { slug: item.url }
          })
        "
        v-for="(item, index) in list.slice(0, 4)"
        :key="item.id"
        class="grid__item"
      >
        <transition
          :name="
            !scrollUp
              ? `fade-card${index + 1}`
              : `fade-card${index + 1}-reverse`
          "
        >
          <div v-show="isActive" class="card" :class="`card-${index + 1}`">
            <div class="card__img">
              <div class="card__category">
                {{ item.sub_category.name }}
              </div>
              <div class="img">
                <img :src="item.image.medium" :alt="item.title" />
              </div>
            </div>
            <div class="card__descr">
              <div class="card__category-title">
                {{ item.sub_category.name }}
              </div>

              <div class="card__title limited-text">
                {{ item.title }}
              </div>
              <div class="data-news">
                <span class="day">{{ handleDate(item.pub_date) }},</span>
                <span class="time">{{ handleTime(item.pub_date) }}</span>
              </div>
            </div>
          </div>
        </transition>
      </router-link>
      <transition name="opacity-card">
        <router-link
          :to="
            $i18nRoute({
              name: 'NewsDetail',
              params: { slug: list[4].url }
            })
          "
          class="grid__item"
          v-show="isActive"
        >
          <div class="card" :class="`card-5`">
            <transition :name="!scrollUp ? `zoom-img` : 'zoom-reverse'">
              <div v-show="isActive" class="card__img">
                <ImageContainer
                  class="img"
                  :src="list[4].image.medium"
                  :thumb="list[4].image.thumbnail"
                  :alt="list[4].title"
                />
              </div>
            </transition>
            <transition :name="!scrollUp ? `fade-descr` : 'fade-descr-reverse'">
              <div v-show="isActive" class="card__descr">
                <div class="card__category-title">
                  {{ list[4].sub_category.name }}
                </div>
                <div class="card__title limited-text">
                  {{ list[4].title }}
                </div>
                <div class="data-news">
                  <span class="day">{{ handleDate(list[4].pub_date) }},</span>
                  <span class="time">{{ handleTime(list[4].pub_date) }}</span>
                </div>
              </div>
            </transition>
          </div>
        </router-link>
      </transition>
    </div>
  </transition>
</template>

<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";

export default {
  components: { ImageContainer },
  props: {
    list: {
      type: Array,
      required: true
    },
    isActive: {
      type: Boolean,
      required: true
    },
    scrollUp: {
      type: Boolean,
      required: true
    }
  },
  setup() {
    return {
      ...useFormatter()
    };
  }
};
</script>

<style lang="scss" scoped>
img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}
.wrapper-bar-3 {
  background: url("../../assets/lifestyle-page/space.jpg") no-repeat;
  background-position: top;
  background-size: cover;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 120%;
}
.grid {
  max-width: 100%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem 0;
  height: 100vh;
  position: relative;
  z-index: 10;
  padding: 10rem 0;
  z-index: -1;

  &__item {
    grid-column: span 1;
    width: 90%;
    margin: 0 auto;
  }
  &__item:nth-child(5) {
    grid-column: span 4;
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    &::before {
      content: "";
      position: absolute;
      width: 100%;
      height: 80%;
      top: 50%;
      transform: translateY(-50%);
      left: 0;
      opacity: 0.1;
      background: #d5d5d5;
      z-index: -1;
    }
  }
  .card__category-title {
    display: none;
  }
  .card__title {
    margin-top: 0.5rem;
  }
  .card__category {
    margin-bottom: 0.2rem;
  }
}
.card-1,
.card-2,
.card-3,
.card-4 {
  .card__img {
    .img {
      height: 12vw;
      &::before {
        content: "";
        position: absolute;
        top: -2px;
        left: -2px;
        background: linear-gradient(
          90deg,
          rgba(255, 0, 0, 1) 9%,
          rgba(255, 188, 0, 1) 22%,
          rgba(255, 226, 0, 1) 37%,
          rgba(22, 255, 0, 1) 52%,
          rgba(0, 146, 255, 1) 66%,
          rgba(0, 31, 255, 1) 81%,
          rgba(186, 0, 236, 1) 100%
        );
        background-size: 400%, 400%;
        width: calc(100% + 4px);
        height: calc(100% + 4px);
        border-radius: 4px;
        z-index: -1;
        animation: animateCard 10s ease-out alternate infinite;
      }
    }
  }
}
.card {
  width: 70%;
  margin: 0 auto;
  &__img {
    .img {
      position: relative;
      z-index: 2;
    }
  }
}
.card-2,
.card-3 {
  margin-top: 5rem;
}
.card-5 {
  display: flex;
  gap: 1rem;
  margin: 0 auto;
  width: 60%;
  .card__img {
    flex: 0 0 40%;
    .img {
      padding-bottom: 70%;
    }
  }
  .card__title {
    font-size: 2em !important;
    line-height: 1.5 !important;
  }
  .card__descr {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .card__category {
    display: none;
  }
  .card__category-title {
    display: block;
  }
}

.delay-enter-active,
.delay-leave-active {
  transition: all 1s ease-out;
}


@media only screen and (max-width: 1366px) {
  .card-5 {
    width: 90%;
    .card__img {
      .img {
        padding-bottom: 70%;
      }
    }
  }
}

/* Portrait */
@media only screen and (min-width: 1024px) and (max-height: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
  .card-1,
  .card-2,
  .card-3,
  .card-4 {
    width: 95%;
    .card__img {
      .img {
        height: 19vw;
      }
    }
  }

  .card-5 {
    width: 90%;
    .card__img {
      .img {
        padding-bottom: 70%;
      }
    }
  }
  .grid__item:nth-child(5)::before {
    height: 50%;
  }
}

/* Landscape */
@media only screen and (min-width: 1024px) and (max-height: 1366px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 1.5) {
  .grid {
    padding-top: 7.5rem;
  }
}
.fade-card1-enter-active,
.fade-card1-leave-active,
.fade-card4-enter-active,
.fade-card4-leave-active {
  transition: all 0.6s ease-in;
}
.fade-card1-enter-active,
.fade-card4-enter-active {
  transition-delay: 0.5s;
}

.fade-card2-enter-active,
.fade-card2-leave-active,
.fade-card3-enter-active,
.fade-card3-leave-active {
  transition: all 0.6s ease-out;
}
.fade-card2-enter-active,
.fade-card3-enter-active {
  transition-delay: 0.5s;
}

.fade-card1-enter-from,
.fade-card4-enter-from {
  transform: translateY(-200%);
}

.fade-card1-leave-to,
.fade-card4-leave-to {
  transform: translateY(-200%);
}

.fade-card2-leave-to,
.fade-card3-leave-to {
  transform: translateY(-200%);
}

.fade-card2-enter-from,
.fade-card3-enter-from {
  transform: translateY(-200%);
}

.fade-card-leave-to {
  transform: translateY(-100%);
}

.fade-card1-reverse-enter-active,
.fade-card1-reverse-leave-active,
.fade-card4-reverse-enter-active,
.fade-card4-reverse-leave-active {
  transition: all 0.6s ease-in;
}

.fade-card2-reverse-enter-active,
.fade-card2-reverse-leave-active,
.fade-card3-reverse-enter-active,
.fade-card3-reverse-leave-active {
  transition: all 0.6s ease-out;
}

.fade-card1-reverse-enter-from,
.fade-card2-reverse-enter-from,
.fade-card3-reverse-enter-from,
.fade-card4-reverse-enter-from {
  transform: translateY(-200%);
}

.fade-card1-reverse-leave-to,
.fade-card2-reverse-leave-to,
.fade-card3-reverse-leave-to,
.fade-card4-reverse-leave-to {
  transform: translateY(-200%);
}

.fade-descr-reverse-enter-active,
.fade-descr-reverse-leave-active,
.zoom-reverse-enter-active,
.zoom-img-enter-active,
.zoom-img-leave-active {
  transition: all 0.6s;
}
.fade-descr-enter-active,
.fade-descr-leave-active {
  transition: all 0.6s;
}
.fade-descr-enter-active {
  transition-delay: 0.2s;
}

.zoom-img-enter-active,
.zoom-img-leave-active {
  transition-delay: 0.3s;
}

.zoom-img-enter-from {
  transform: scale(0);
}
.zoom-reverse-leave-active {
  transition: all 0.6s;
}
.zoom-reverse-leave-to {
  transform: scale(0);
}
.zoom-img-leave-to {
  transform: scale(0);
}
.fade-descr-enter-from {
  opacity: 0;
  transform: translateY(-10%);
}
.fade-descr-reverse-leave-to {
  opacity: 0;
  transform: translateY(-10%);
}

.opacity-card-enter-active,
.opacity-card-leave-active {
  transition: all 0.5s;
}

.opacity-card-leave-to {
  opacity: 1;
}
</style>
<style>
@keyframes fade-input {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
